import axios from "axios";
import { apiV1, apiV2 } from "./config";

const APIs = {
  v1: apiV1,
  v2: apiV2,
};

const cancelToken = axios.CancelToken;
let cancel;
let arrayCancelar = [];

// GET - Standard request
export async function getService({ endpoint, params, options, api = "v1" }) {
  const response = await APIs[api].get(endpoint, { params, ...options });
  return response.data || response;
}

// GET - ArrayBuffer response (for files)
export async function getServiceByte({ endpoint, params, api = "v1" }) {
  try {
    const response = await APIs[api].get(endpoint, {
      params,
      responseType: "arraybuffer",
    });

    if (response instanceof ArrayBuffer) {
      return response;
    } else {
      console.error("Buffer de array recebido inválido");
      throw new Error("Buffer de array inválido");
    }
  } catch (error) {
    console.error("Erro no getServiceByte:", error);
    throw error;
  }
}

// GET - Download request
export async function getDownloadService({
  endpoint,
  params,
  options,
  api = "v1",
}) {
  const response = await APIs[api].get(endpoint, { params, ...options });
  return response;
}

// POST - Standard request
export async function postService({ endpoint, postData, options, api = "v1" }) {
  const configHeader = { headers: { "content-type": "application/json" } };
  const response = await APIs[api].post(endpoint, postData, {
    ...configHeader,
    ...options,
  });
  return response.data || response;
}

// PUT - Standard request
export async function putService({ endpoint, putData, options, api = "v1" }) {
  const response = await APIs[api].put(endpoint, putData, options);
  return response.data || response;
}

// PUT - S3 file upload with progress tracking and cancel support
export async function putS3File({ url, file, progress }) {
  const config = {
    headers: {
      "Content-Type": file._meta.type || "application/octet-stream",
    },
    onUploadProgress: (event) => progress(event, file),
    cancelToken: new cancelToken(function executor(ref) {
      arrayCancelar.push({ ref, file });
      cancel = ref;
    }),
  };

  return axios.put(url, file._meta, config);
}

// PATCH - Standard request
export async function patchService({
  endpoint,
  patchData,
  options,
  api = "v1",
}) {
  const response = await APIs[api].patch(endpoint, patchData, options);
  return response.data || response;
}

// DELETE - Standard request
export async function deleteService({ endpoint, options, api = "v1" }) {
  const response = await APIs[api].delete(endpoint, options);
  return response.data || response;
}

// DELETE - With query string parameters
export async function deleteServiceQString({ endpoint, params, api = "v1" }) {
  const response = await APIs[api].delete(endpoint, { params });
  return response.data || response;
}

// Cancel file upload
export async function cancelRequest(file) {
  arrayCancelar.forEach((item) => {
    if (item.file.originalName === file.originalName) {
      cancel = item.ref;
      cancel("Cancelado");
    }
  });
}
